import type { NwFormSubmissionInput, FormSubmissionResponse } from '@qdf/shared';
import { apiRequest } from './client.js';

export async function submitNwForm(
  data: NwFormSubmissionInput,
): Promise<FormSubmissionResponse> {
  return apiRequest<FormSubmissionResponse>('/v1/nw-form-submissions', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

/**
 * Public form bootstrap: the Cloudflare Turnstile site key (public by
 * design), or null when Turnstile is not configured for this environment.
 */
export async function fetchNwFormConfig(): Promise<{ turnstileSiteKey: string | null }> {
  return apiRequest<{ turnstileSiteKey: string | null }>('/v1/nw-form-config', {
    method: 'GET',
  });
}
